import 'core-js/stable'; 
import 'regenerator-runtime/runtime';
import '../sass/app.scss'

import Vue from 'vue'
import Clipboard from 'clipboard'

import './components/location-finder'
import './components/check-zip'
import './components/static-map'
import './components/reviews'
import Flickity from 'flickity'
import SmoothScroll from 'smooth-scroll'

let scroll = new SmoothScroll('a[href*="#"]', {
  header: 'header.main',
  offset: 10
})

let promoItem = document.querySelector('#promo')

if(promoItem) {
    setTimeout(() => {
        document.querySelector('#promo').classList.add('active')
    }, 1000)
}

let promoBox = document.querySelector('#step-1')

if(promoBox) {
    promoBox.addEventListener('click', (e) => {
        e.preventDefault()
        document.querySelector('#promo').classList.toggle('open')
    })
}

let promoBoxClose = document.querySelector('.close.promo-box')

if(promoBoxClose) {
    promoBoxClose.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        document.querySelector('#promo').classList.remove('open')
    })
}

let bus = new Vue()

// Open and Close Menu
let menu = document.querySelector('[data-menu]')
if(menu) {
  menu.addEventListener('click',(e) => {
    e.preventDefault()
    document.body.classList.toggle('menu-open')
  })
}

class ProgressiveVideo {
  constructor(video = null) {
    if(!video) return
    this.el = video
    this.srcEl = video.querySelectorAll('source')
    this.width = 875
    this.loaded = false

    this.init()
  }

  init() {
    this.run()

    window.addEventListener('resize', e => {
      window.requestAnimationFrame(f => {
        this.run()
      })
    })
  }

  run() {
    if(window.innerWidth <= this.width) {
      if(!this.loaded) return
      console.log('disabling video')
      this.srcEl.forEach(el => {
        el.src = null
      })

      return this.loaded = false
    }

    if(this.loaded) return

    console.log('enabling video')
    this.srcEl.forEach(el => {
      el.src = el.getAttribute('data-src')
    })

    this.el.load()
    this.el.play()

    return this.loaded = true
  }
}


new ProgressiveVideo(document.querySelector('.bg'))

// Search Dropdown
let search_listener = false
let search_toggle = document.querySelector('[data-toggle-search]')
let search_dropdown = document.querySelector('.search-dropdown')
let search_field = search_dropdown.querySelector('input[type="text"]')
if(search_toggle) search_toggle.addEventListener('click', e => {
  e.preventDefault()
  e.stopPropagation()
  document.body.classList.toggle('search-open')
  if(document.body.classList.contains('search-open')) search_field.focus()
  if(search_listener) return document.body.removeEventListener('click', closeSearch)
  search_listener = document.body.addEventListener('click', closeSearch)
})

if(search_dropdown) search_dropdown.addEventListener('click', e => {
  e.stopPropagation()
})

// Send GA page view when using instant search
if(search_field) {
  let searchTypingTimeout = null
  search_field.addEventListener('input', e => {
    if(searchTypingTimeout) {
      clearTimeout(searchTypingTimeout)
    }

    searchTypingTimeout = setTimeout(() => {
      const query = encodeURIComponent(search_field.value)
      ga('send', 'pageview', '/?q=' + query)
    }, 2000)
  })
}

function closeSearch(e) {
  // e.preventDefault()
  document.body.classList.remove('search-open')
}


Array.from(document.querySelectorAll('.testimonials')).forEach(el => {
  let options = {
    cellAlign: 'left',
    prevNextButtons: false,
    autoPlay: 6000
  }
  if(window.innerWidth < 875) options.groupCells = 1
  new Flickity(el, options)
})

let promo = document.querySelector('.promo')
if(promo) {
  let close = promo.querySelector('[data-close]')
  close.addEventListener('click', e => {
    console.log('close')
    e.preventDefault()
    e.stopPropagation()
    promo.remove()
  })
}

// State Laws Button
// Array.from(document.querySelectorAll('.geolocation-button')).forEach(el => {
//   new Vue({
//     el,
//     data() {
//       return {
//         location: {},
//         url: ''
//       }
//     },
//     mounted() {
//       axios.get('http://api.ipstack.com/check?access_key=0be5c00781df0ec7c1ce45a33eddf668&format=1').then(location => {
//         this.location = location.data
//         this.url = `/state-laws/${this.location.region_name.toLowerCase()}?zip=${this.location.zip}`
//       }).catch(err => {})
//     }
//   })
// })

// Accordions
Array.from(document.querySelectorAll('.accord')).forEach(el => {
  new Vue({
    el,
    data() {
      return {
        active: false,
        modalOpen: false,
      }
    },
    methods: {
      setActive(i = false) {
        if(i && i === this.active) return this.active = false
        if(i) return this.active = i
        return this.active = false
      }
    },
    mounted() {
        bus.$on('accordion', (id) => {
            this.active = Number(id)
        })

        if(QueryParam('section')) {
            console.log('going to section')
            let el = this.$el.querySelector('#section-'+QueryParam('section'))
            if(el) {
                this.active = Number(el.getAttribute('data-row'))
                let scroll = new SmoothScroll(null, {
                    header: 'header.main',
                    offset: 10
                })
                scroll.animateScroll(el)
            }
        }
    }
  })
})

const exitIntent = document.querySelector('.exit-intent')
if(exitIntent) new Vue({
  el: exitIntent,
  data() {
    return {
      modalOpen: false,
      protected: false,
      shouldTriggerIntent: false,
    }
  },
  methods: {
    getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    },
    initModal() {
      if(this.protected) return;
      
      document.addEventListener('mouseout', e => {
        if(e.toElement !== null || e.relatedTarget !== null || this.protected || this.modalOpen) return
        
        this.protected = this.modalOpen = true
      })
    }
  },
  created() {
    // Do not trigger modal if they have submitted a form
    if(this.getCookie('draeger_submitted_form')) this.protected = true

    // Do not trigger modal if they have clicked to call
    if(sessionStorage.getItem('draegerClickedToCall')) this.protected = true
  },
  mounted() {
    // Only trigger intent after they have been on the site for 2 seconds
    setTimeout(() => {
      this.initModal()
    }, 5000)

    document.addEventListener('keydown', event => {
      if(event.key == 'Escape' && this.modalOpen == true) this.modalOpen = false
    })

    // Disable modal if any link with a phone number is clicked
    Array.from(document.querySelectorAll('[href^="tel:"]')).forEach(el => {
      el.addEventListener('click', e => {
        sessionStorage.setItem('draegerClickedToCall', true)
        this.protected = true
      })
    })


    // Show modal if form has validation errors
    let failedForm = this.$el.querySelector('.gform_validation_error')
    if(failedForm) {
      this.modalOpen = true
      this.protected = false
    }

  }
})


// Timeline
// import VTooltip from 'v-tooltip'
// Vue.use(VTooltip)

$.fn.attachDragger = function(){
  let attachment = false, lastPosition, position, difference
  $( $(this).selector ).on("mousedown mouseup mousemove",function(e){
      if( e.type == "mousedown" ) attachment = true, lastPosition = [e.clientX, e.clientY]
      if( e.type == "mouseup" ) attachment = false
      if( e.type == "mousemove" && attachment == true ){
          position = [e.clientX, e.clientY]
          difference = [ (position[0]-lastPosition[0]), (position[1]-lastPosition[1]) ]
          $(this).scrollLeft( $(this).scrollLeft() - difference[0] )
          $(this).scrollTop( $(this).scrollTop() - difference[1] )
          lastPosition = [e.clientX, e.clientY]
      }
  });
  $(window).on("mouseup", function(){
      attachment = false
  })
}

Array.from(document.querySelectorAll('.timeline-wrapper')).forEach(el => {
  new Vue({
    el,
    data() {
      return {
        active: 1,
        total: 0,
      }
    },
    methods: {
      popupContent(html) {
        return html
      },
      back() {
        return this.active = (this.active === 1) ? (this.total) : this.active-1
      },
      next() {
        return this.active = (this.active === this.total) ? 1 : this.active+1
      }
    },
    mounted() {
      this.total = Array.from(this.$el.querySelectorAll('.timeline-stop')).length
      $('.timeline').attachDragger()
    } 
  })
})


// Map
Array.from(document.querySelectorAll('.map-wrapper')).forEach(el => {
  new Vue({
    el,
    data() {
      return {
        active: false,
        hash: false,
        scroll: null,
      }
    },
    methods: {
      isActive(slug) {
        return this.active === slug ? ['active'] : []
      },
      go(slug) {
        if(document.querySelector('html').getAttribute('lang') == 'es-MX') slug += '-es'
        if(!this.hash) return window.location.href = '/state-laws/'+slug
        if(this.hash) {
            let a = document.querySelector(`#section-${slug}`)
            this.scroll.animateScroll(a)
            bus.$emit('accordion', a.getAttribute('data-row'))
        }
      }
    },
    created() {
      this.active = window.slug.replace('-es', '')
    },
    mounted() {
        this.scroll = new SmoothScroll(null, {
            header: 'header.main',
            offset: 10
        })
        if(this.$el.classList.contains('link-to-hash')) this.hash = true
    }
  })
})

let ff
if(document.querySelector('.freezeframe')) {
  ff = new freezeframe('.freezeframe')
  ff.freeze()
}

function play() {
  if(!ff) return;

  ff.trigger('.frame-1')
  setTimeout(() => {
    ff.release()
    ff.trigger('.frame-2')
  }, 4000)

  setTimeout(() => {
    ff.release()
    ff.trigger('.frame-3')
  }, 4000 + 4000)

  setTimeout(() => {
    ff.release()
    play()
  }, 4000 + 4000 + 3200)

  imagesLoaded('.frame-1', () => {
    console.log('starting')
    setTimeout(play, 1000)
  })
}

function QueryParam(param) {
  let query = window.location.search.substring(1)
  let vars = query.split("&")
  for (var i=0;i<vars.length;i++) {
      let pair = vars[i].split("=")
      if(pair[0] == param){ return unescape(pair[1]) }
  }
  return(false)
}

// Lead Form Conditional Name Fields
const lead_form = document.querySelector('#gform_wrapper_26')
if (lead_form) {
  const is_short = lead_form.querySelector('#input_26_18').value;
  if (is_short === 'true') {
    const first_name_field = lead_form.querySelector('#field_26_1');
    const first_name_field_input = first_name_field.querySelector('input');
    const first_name_field_label = first_name_field.querySelector('label');
    const first_name_field_label_required = first_name_field_label.querySelector('span');
    first_name_field_input.setAttribute('placeholder', 'First and Last Name *');
    first_name_field_label.innerHTML = 'First and Last Name ';
    first_name_field_label.appendChild(first_name_field_label_required);
  }
}

// Contact Form Conditional
const training_form = document.querySelector('#gform_wrapper_32')
if (training_form) {
  const info_requested = training_form.querySelector('#choice_32_9_1')
  const address_field = training_form.querySelector('#field_32_10')
  const zip_field = training_form.querySelector('#field_32_11')
  address_field.style.display = 'none'
  zip_field.style.display = 'none'

  info_requested.addEventListener('change', e => {
    if (e.target.checked) {
      address_field.style.display = 'block'
      zip_field.style.display = 'block'
    } else {
      address_field.style.display = 'none'
      zip_field.style.display = 'none'
    }
  })
}

let infographicEmbed = document.querySelector('.embed-infographic')
let infographicEmbedBtn = document.querySelector('.embed-infographic-copy')

if(infographicEmbed && infographicEmbedBtn) {
  let cb = new Clipboard(infographicEmbedBtn, {
    text: trigger => {
      return infographicEmbed.value
    }
  })

  infographicEmbedBtn.addEventListener('click', e => {
    e.preventDefault()
  })

  cb.on('success', e => {
    e.trigger.innerText = 'Copied!'
  })

}

// Tracking Phone #s
if ( typeof( window.defaultPhone ) !== 'undefined' && typeof( window.trackingNumbers ) !== 'undefined' ) {
  if ( window.defaultPhone.length > 9 && window.trackingNumbers.length > 0 ) {
    const params = new URLSearchParams( document.location.search );
    let newPhone = null;
    
    if ( params.get( 'phone' ) === 0 || params.get( 'phone' ) === '0' ) {
      localStorage.removeItem( 'rgDynamicPhone' );
    }
    else {
      for ( const [i, tn] of trackingNumbers.entries() ) {
        if ( params.get( tn.paramName ) == tn.paramValue ) {
          newPhone = tn.phoneNumber;
          localStorage.rgDynamicPhone = newPhone;
          break;
        }
      }
      
      if ( typeof( localStorage.rgDynamicPhone ) !== 'undefined' ) {
        if ( localStorage.rgDynamicPhone.length < 9 ) {
          localStorage.removeItem( 'rgDynamicPhone' );
        }
        else {
          newPhone = localStorage.rgDynamicPhone;
        }
      }
    }
    
    if ( typeof( localStorage.rgDynamicPhone ) !== 'undefined' ) {
      const phoneRegex = new RegExp( defaultPhone, 'g' );
      const telLinks = document.body.querySelectorAll( 'a[href="tel:' + defaultPhone + '"]' );
      
      telLinks.forEach( (a) => {
        a.href = 'tel:' + newPhone;
        a.innerHTML = a.innerHTML.replace( phoneRegex, newPhone );
      });
    }
  }
}

let heroLoaded = false;
const heroOnLoadDelay = 3500;

// Hero Video after load & user interaction to delay loading of Vimeo scripts
const loadHero = (event) => {
  if ( false === heroLoaded ) {
    heroLoaded = true;
    const heroHolder = document.getElementById( 'hero-video-holder' );
    
    if ( heroHolder != null ) {
      const heroIframe = document.createElement( 'iframe' );
      heroIframe.classList.add( 'bg-video' );
      heroIframe.src = 'https://player.vimeo.com/video/367778566?background=true';
      heroIframe.setAttribute( 'frameborder', 0 );
      heroIframe.setAttribute( 'allow', 'autoplay; fullscreen' );
      heroIframe.setAttribute( 'allowfullscreen', true );
      heroHolder.appendChild( heroIframe );
    }
  }
  
  document.body.removeEventListener( 'mouseover', loadHero );
  document.removeEventListener( 'scroll', loadHero );
};

document.body.addEventListener( 'mouseover', loadHero );
document.addEventListener( 'scroll', loadHero );
window.addEventListener( 'load', () => {
  setTimeout( () => {
    loadHero(); 
  }, heroOnLoadDelay );
});
